import {CUSTOMER_GROUP_STATUS} from 'Pages/apps/default/customerGroups/const';

/**
 * Data object representing the customer groups list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class CustomerGroupsListItemDataObject {
	/**
	 * @param {string} id - Customer group's DB ID.
	 * @param {string} name - Customer group's name.
	 * @param {string} projectName - Name of the project this customer group is for.
	 * @param {CustomerGroupStatus} status - Status of the customer group.
	 * @param {?number} customerCount - Number of customers in the group. 
	 */
	constructor(id, name, projectName, status, customerCount) {
		this.id = id;
		this.name = name;
		this.projectName = projectName;
		this.status = status;
		this.customerCount = customerCount;
	}
}

/**
 * Data object representing the customer groups item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class CustomerGroupsItemDataObject {
	/**
	 * @param {string|null} [id=null] - Customer group's DB ID.
	 * @param {string} [name=''] - Customer group's name.
	 * @param {string} [description=''] - Customer group's description.
	 * @param {?string} [projectId=null] - DB ID of the project this customer group is for.
	 * @param {?CustomerGroupStatus} [status='ACTIVE'] - Status of the customer group.
	 */
	constructor(id = null, name = '', description= '', projectId = null, status = CUSTOMER_GROUP_STATUS.ACTIVE) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.projectId = projectId;
		this.status = status;
	}
}